import axios from "axios";

export let baseUrl = `${process.env.REACT_APP_BASE_URL}api/`;
export const socketUrl = process.env.REACT_APP_BASE_URL;

// export let baseUrl = "https://cp5h187s-5001.inc1.devtunnels.ms/api/";
// export let socketUrl = "https://cp5h187s-5001.inc1.devtunnels.ms/";

const api = async (path, params, method) => {
  const lang = localStorage.getItem("currentLang") || "ro";

  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": lang,
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
